// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"ee0e7066","241":"ee0e7066","310":"ee0e7066"}[chunkId] + ".chunk.css";
};